import { MvpCalculatorWidget } from "@/components/calculators/mvp-calculator-widget"
import { Button } from "@/components/ui/button"
import { ModalFrame } from "./modal-frame"

interface MvpCalculatorModalProps {
  isOpen: boolean
  onClose: () => void
  onDismiss: () => void
}

export function MvpCalculatorModal({ isOpen, onClose, onDismiss }: MvpCalculatorModalProps) {
  if (!isOpen) return null

  return (
    <ModalFrame
      type="MVP Calculator"
      title="Forecast your MVP scope in 60 seconds"
      description="Toggle the scope, timeline, and AI stack to see what your production-ready build will cost. Save the quote to sync it straight into our CRM for follow-up."
      accent="accent"
      highlight="Psst: Saving the quote locks this pricing for 7 days."
    >
      <div className="space-y-6">
        <MvpCalculatorWidget
          mode="modal"
          onQuoteSaved={() => {
            onClose()
            onDismiss()
          }}
        />
        <div className="flex flex-col gap-3 rounded-2xl border border-accent/40 bg-accent/10 p-4 text-sm text-accent-foreground md:flex-row md:items-center md:justify-between">
          <span className="font-medium">Want us to walk you through the build?</span>
          <Button
            variant="outline"
            onClick={() => {
              onClose()
              onDismiss()
              window.open("https://cal.com/buildwithrishi/15min", "_blank", "noopener,noreferrer")
            }}
          >
            Book the founder in
          </Button>
        </div>
      </div>
    </ModalFrame>
  )
}

